import { useLocation } from 'react-router-dom'

export function usePageTitle(): string {
  const { pathname } = useLocation()
  const segment = pathname.split('/').filter(Boolean)[0] ?? 'dashboard'
  return segment
    .split('-')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}
